export enum TaskCategory {
  FoodSource = 'food_source',
  StandPrep = 'stand_prep',
  TrailCameras = 'trail_cameras',
  Scouting = 'scouting',
  GearEquipment = 'gear_equipment',
  PropertyInfrastructure = 'property_infrastructure',
  HabitatManagement = 'habitat_management',
  RegulatoryAdmin = 'regulatory_admin',
  PostSeason = 'post_season',
  PredatorControl = 'predator_control',
  WaterholeManagement = 'waterhole_management',
  WildlifeStructures = 'wildlife_structures',
  MineralNutrition = 'mineral_nutrition',
  NeighborAccess = 'neighbor_access',
  HerdData = 'herd_data',
  MockScrapes = 'mock_scrapes',
  TreePlanting = 'tree_planting',
  Other = 'other',
}

export enum TimingAnchor {
  OpenerRelative = 'opener_relative',
  CalendarDate = 'calendar_date',
  FrostDate = 'frost_date',
  RutRelative = 'rut_relative',
}

export interface Task {
  id: string;
  templateTaskId?: string | null; // Null if user-created
  seasonId: string;
  propertyId?: string;
  waypointId?: string;
  title: string;
  description: string;
  category?: TaskCategory; // Required in M11 rework
  selectedAction?: string; // From predefinedActions
  dueDate: string; // ISO 8601 date
  timingAnchor?: TimingAnchor; // Required in M11 rework
  offsetDays: number;
  dependsOn?: string[]; // Task IDs — generated from template dependencies
  blocked?: boolean; // Computed: true if any predecessor incomplete
  completed: boolean;
  completedAt?: string;
  snoozedUntil?: string; // ISO 8601 date
  sortOrder: number;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

// `blocked` is computed by the adapter; new v2.0 fields are optional for backward compat.
// `id` is optional — callers like ChecklistEngine pre-assign IDs for dependency resolution.
export type CreateTaskInput = Omit<Task, 'id' | 'createdAt' | 'updatedAt'> & { id?: string };
export type UpdateTaskInput = Partial<CreateTaskInput>;
